<template>
  <div class="row d-flex align-items-stretch">
    <div class="col-12 col-sm-3">
      <div class="card h-100" :class="getSentimentsColor(data)">
        <div
          class="card-body d-flex justify-content-center text-center text-light"
        >
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h5 class="card-title">Pergunta Textual</h5>
              <h6 class="card-subtitle">Sentimento</h6>
              <h2 class="mb-0">{{ getSentimentsText(data) }}</h2>
              <button
                class="btn btn-light btn-sm mt-2"
                title="Detalhar"
                data-bs-toggle="collapse"
                href="#collapse-text-details"
              >
                <i class="ph ph-list-magnifying-glass"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-9">
      <div class="card h-100">
        <table class="table table-sm table-hover table-striped">
          <thead>
            <tr>
              <th>Tipo</th>
              <th class="text-center">Quantidade</th>
              <th class="text-center">Porcentagem</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Positivo</td>
              <td class="text-center">{{ data.positive }}</td>
              <td class="text-center">
                {{ calculatePercentage(data.positive) }}%
              </td>
            </tr>
            <tr>
              <td>Neutro</td>
              <td class="text-center">{{ data.neutral }}</td>
              <td class="text-center">
                {{ calculatePercentage(data.neutral) }}%
              </td>
            </tr>
            <tr>
              <td>Negativos</td>
              <td class="text-center">{{ data.negative }}</td>
              <td class="text-center">
                {{ calculatePercentage(data.negative) }}%
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-12 collapse" id="collapse-text-details">
      <div class="card table-responsive mt-2">
        <table
          class="table table-hover table-striped table-sm fs-sm"
          :id="dataTable.id"
        >
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Solicitante</th>
              <th>Técnico</th>
              <th class="text-center">Ticket</th>
              <th class="text-center">Enviado</th>
              <th class="text-center">Respondido</th>
              <th>Pergunta</th>
              <th class="text-center">Resposta</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in data.data" :key="item.id">
              <td>{{ item.organization }}</td>
              <td>{{ item.requester }}</td>
              <td>{{ item.technicianName }}</td>
              <td class="text-center">{{ item.ticketId }}</td>
              <td class="text-center">
                <span class="d-none">{{ item.sendAt }}</span>
                {{ dateTimeSqlToDateTimeBR(item.sendAt) }}
              </td>
              <td class="text-center">
                <span class="d-none">{{ item.answerAt }}</span>
                {{ dateTimeSqlToDateTimeBR(item.answerAt) }}
              </td>
              <td>{{ item.field1 }}</td>
              <td class="text-center">{{ item.value }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { dateTimeSqlToDateTimeBR } from '@/utils/date'
import '@/utils/basicDataTableExtend'

export default {
  name: 'AnswerText',

  props: {
    data: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      dateTimeSqlToDateTimeBR,
      dataTable: {
        id: 'dataTableListTextMessage',
        order: [[4, 'DESC']],
      },
    }
  },

  methods: {
    createDataTable() {
      if (this.table) {
        this.table.destroy()
      }
      this.table = window.$(`#${this.dataTable.id}`).DataTable(this.dataTable)
    },

    getSentimentsColor(anwser) {
      if (
        anwser.positive > anwser.negative &&
        anwser.positive > anwser.neutral
      ) {
        return 'bg-success'
      }
      if (
        anwser.negative > anwser.positive &&
        anwser.negative > anwser.neutral
      ) {
        return 'bg-danger'
      }
      return 'bg-warning'
    },

    getSentimentsText(anwser) {
      if (
        anwser.positive > anwser.negative &&
        anwser.positive > anwser.neutral
      ) {
        return 'Positivo'
      }
      if (
        anwser.negative > anwser.positive &&
        anwser.negative > anwser.neutral
      ) {
        return 'Negativo'
      }
      return 'Neutro'
    },

    calculatePercentage(value) {
      return (
        (value /
          (this.data.positive + this.data.negative + this.data.neutral)) *
        100
      ).toFixed(2)
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
